var map = {
	"./bet-tnc-cn.svg": 759,
	"./fifa-tnc-cn.svg": 760,
	"./leaderboard-tnc-cn.svg": 761,
	"./lucky-tnc-cn.svg": 762,
	"./term-condition-bm.svg": 763,
	"./term-condition-cn.svg": 764,
	"./term-condition-id.svg": 765,
	"./term-condition.svg": 766,
	"./term-content.png": 767,
	"./term-footer.png": 768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2354;